import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LanguageService } from '../services/language.service';

@Pipe({ name: 'localizedDate', pure: false })
export class LocalizedDatePipe implements PipeTransform {
  constructor(private languageService: LanguageService) { }

  transform(value: any, format: string = 'shortDate'): any {

    // If value is a string, try to parse it as a Date
  let dateValue = value;
  if (typeof value === 'string') {
    const parsedDate = new Date(value);
    if (!isNaN(parsedDate.getTime())) {
      dateValue = parsedDate;
    }
  }

  // Get current locale from language service
  const locale = this.languageService.getCurrentLanguage();

  // Use Angular DatePipe to format the date
  const datePipe = new DatePipe(locale);
  var dateString = datePipe.transform(dateValue, format);
  // replate spaces with non-breaking spaces to prevent line breaks in UI
  return dateString ? dateString.replace(/ /g, '\u00A0') : dateString;
  }
}